export default __webpack_public_path__ + "static/media/occupation.9276fcb6.svg";